export default __webpack_public_path__ + "static/media/com-red.a997e4ba.svg";